import { getAPIUrl } from '../helpers/App';

export const APIgetArchiveSummary = (collections, files, action) => (
  window.axios.post(getAPIUrl('/archive/summary'), { collections, files, action })
    .then(response => (response))
);
